var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "LOCK",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #LOCK .cls-1 {\n        fill: #ff7600;\n        stroke: #ff7600;\n      }\n\n      #LOCK .cls-2 {\n        fill: #151517;\n      }\n\n      #LOCK .cls-3 {\n        stroke: none;\n      }\n\n      #LOCK .cls-4 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pfd_LOCK",
    transform: "translate(-1251 -189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_369",
    "data-name": "Ellipse 369",
    className: "cls-1",
    transform: "translate(1251 189)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 12,
    cy: 12,
    r: 11.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "LOCK-2",
    "data-name": "LOCK",
    transform: "translate(1253 190.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_136",
    "data-name": "Pfad 136",
    className: "cls-2",
    d: "M10.5,20.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_138",
    "data-name": "Pfad 138",
    className: "cls-2",
    d: "M10.5.5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_934",
    "data-name": "Gruppe 934",
    transform: "translate(6 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_328",
    "data-name": "Pfad 328",
    className: "cls-2",
    d: "M9,15.869H0V8.9H9ZM5.769,11.346a1.29,1.29,0,0,0-1.292-1.292,1.251,1.251,0,0,0-1.246,1.292,1.3,1.3,0,0,0,.6,1.108l-.323,1.938H5.492l-.323-1.938A1.416,1.416,0,0,0,5.769,11.346Z",
    transform: "translate(0 -4.792)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_329",
    "data-name": "Pfad 329",
    className: "cls-2",
    d: "M4.354,3A1.846,1.846,0,1,1,8.046,3V4.569H9.2V3a3,3,0,1,0-6,0V4.569H4.354Z",
    transform: "translate(-1.723)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.97a193b65b027b34973c42098708a925.svg";
export { ForwardRef as ReactComponent };